var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarningTriangle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.95892 1.58616C8.8685 1.40968 8.73113 1.26157 8.56194 1.15815C8.39275 1.05472 8.1983 1 8.00001 1C7.80171 1 7.60726 1.05472 7.43807 1.15815C7.26888 1.26157 7.13151 1.40968 7.0411 1.58616L1.11526 13.4378C1.03261 13.6018 0.993258 13.7842 1.00094 13.9678C1.00863 14.1513 1.0631 14.3297 1.15918 14.4863C1.25525 14.6428 1.38975 14.7722 1.54989 14.8621C1.71003 14.9521 1.8905 14.9996 2.07417 15.0001H13.9258C14.1095 14.9996 14.29 14.9521 14.4501 14.8621C14.6103 14.7722 14.7448 14.6428 14.8409 14.4863C14.9369 14.3297 14.9914 14.1513 14.999 13.9678C15.0068 13.7842 14.9674 13.6018 14.8847 13.4378L8.95892 1.58616Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.99976 5.84229V9.34392",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.00007 12.3068C7.85131 12.3068 7.73071 12.1862 7.73071 12.0374C7.73071 11.8886 7.85131 11.7681 8.00007 11.7681",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M8 12.3068C8.14876 12.3068 8.26936 12.1862 8.26936 12.0374C8.26936 11.8886 8.14876 11.7681 8 11.7681",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgWarningTriangle;